export const createStyles = (theme?: any, shouldGreyOut = false) => ({
  overflowText: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actionButtonWrapper: {
    ml: 'auto',
    flexShrink: 0,
  },
  actionIconButton: {
    width: 32,
    height: 32,
    minHeight: 32,
  },
  actionIcon: {
    backgroundColor: theme?.palette?.background?.paper,
    width: 24,
    height: 24,
    minHeight: 24,
    borderRadius: '50%',
    color: theme?.palette?.primary?.main,
  },
  listItem: {
    width: '100%',
    borderBottom: '1px solid',
    borderColor: 'divider',
    '& .MuiListItem-root > .MuiBox-root': {
      minWidth: 0,
      overflow: 'hidden',
    },
    '& .MuiListItemText-root': {
      m: 0,
      overflow: 'hidden',
    },
    '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
      opacity: shouldGreyOut ? 0.6 : 1,
      fontWeight: 400,
    },
  },
  listItemRoot: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    p: 0,
    pb: '0.5rem',
  },
  avatar: {
    width: 36,
    height: 36,
    mr: '0.75rem',
    opacity: shouldGreyOut ? 0.6 : 1,
    flexShrink: 0,
  },
  disabledWrapper: {
    width: '100%',
    cursor: 'default',
  },
});
